import { useLocation } from '../contexts/LocationContext'
import StoreLogoComponent from './StoreLogoComponent'
import { STORE_LOGOS } from '../services/storeLogos'



const StoreLocationModal = () => {
  const { currentStore, setCurrentStore, isLocationModalOpen, setLocationModalOpen } = useLocation()

  if (!isLocationModalOpen) return null

  const handleStoreSelect = (storeId: string) => {
    setCurrentStore(storeId)
    setLocationModalOpen(false)
  }

  const handleNotInStore = () => {
    setCurrentStore(null)
    setLocationModalOpen(false)
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-md w-full p-6">
        <div className="text-center mb-6">
          <h2 className="text-xl font-bold text-gray-900 mb-2">
            Missä kaupassa olet?
          </h2>
          <p className="text-gray-600 text-sm">
            Valitse nykyinen sijaintisi helppoa tuotteiden lisäämistä varten
          </p>
        </div>

        {/* Not in store option */}
        <button
          onClick={handleNotInStore}
          className={`w-full p-4 rounded-lg border-2 mb-4 transition-all ${
            currentStore === null
              ? 'border-blue-500 bg-blue-50'
              : 'border-gray-200 hover:border-gray-300'
          }`}
        >
          <div className="flex items-center justify-center">
            <div className="text-2xl mr-3">🏠</div>
            <div>
              <div className="font-medium">En ole kaupassa</div>
              <div className="text-sm text-gray-600">Näytä kaikki kaupat</div>
            </div>
          </div>
        </button>

        {/* Store grid */}
        <div className="grid grid-cols-2 gap-3 mb-6">
          {Object.entries(STORE_LOGOS).map(([storeId, storeData]) => (
            <button
              key={storeId}
              onClick={() => handleStoreSelect(storeId)}
              className={`p-4 rounded-lg border-2 transition-all ${
                currentStore === storeId
                  ? 'border-blue-500 bg-blue-50'
                  : 'border-gray-200 hover:border-gray-300'
              }`}
            >
              <div className="text-center">
                <div className="mx-auto mb-2">
                  <StoreLogoComponent 
                    storeId={storeId} 
                    size="lg"
                    showBrandColors={false}
                  />
                </div>
                <div className="font-medium text-sm">{storeData.name}</div>
              </div>
            </button>
          ))}
        </div>

        {/* Cancel button */}
        <button
          onClick={() => setLocationModalOpen(false)}
          className="w-full py-2 text-gray-600 hover:text-gray-800 transition-colors"
        >
          Peruuta
        </button>
      </div>
    </div>
  )
}

export default StoreLocationModal